// ==============================|| OVERRIDES - TABLE ROW ||============================== //

export default function TableBody(theme) {
  const hoverStyle = {
    '&:hover': {
      backgroundColor: 'rgba(31, 91, 64, 0.04)'
    }
  };

  return {
    MuiTableBody: {
      styleOverrides: {
        root: {
          backgroundColor: theme.vars.palette.background.paper,
          '& .MuiTableRow-root': {
            ...hoverStyle,
            transition: 'background-color 0.15s ease',
            '&:nth-of-type(even)': {
              backgroundColor: 'rgba(31, 91, 64, 0.02)'
            },
            '&:nth-of-type(even):hover': {
              backgroundColor: 'rgba(31, 91, 64, 0.05)'
            }
          }
        }
      }
    }
  };
}
